<template lang="html">
    <div style="width:100%;" :class="[ expandVideoData  ? '' : 'open-video-height']">
        <div id="player" style="height: 200px"></div>
        <div class="d-flex video-tool-wrap mt-2">
            <i v-bind:class="[{ 'fa-turn-on': isRepeating}, 'fas', 'fa-redo-alt', 'ml-2', 'mr-3', 'my-auto']"
               style="cursor:pointer;" v-on:click="repeatSentence()"
               data-toggle="tooltip" data-placement="top" title="單句重複撥放模式的切換"></i>
            <i class="fas fa-backward mr-3 my-auto" style="cursor:pointer;" v-on:click="prevCaption()"
               data-toggle="tooltip" data-placement="top" title="跳撥到前一個例句"></i>
            <i class="fas fa-play mr-3 my-auto" v-bind:style="{ display: playerState==1?'none':'block', cursor: 'pointer'}"
               v-on:click="playVideo()" data-toggle="tooltip" data-placement="top" title="撥放影片"></i>
            <i class="fas fa-pause mr-3 my-auto" v-bind:style="{ display: playerState==1? 'block':'none', cursor: 'pointer'}"
               v-on:click="pauseVideo()" data-toggle="tooltip" data-placement="top" title="暫停影片"></i>
            <i class="fas fa-forward mr-3 my-auto" style="cursor:pointer;" v-on:click="nextCaption()"
               data-toggle="tooltip" data-placement="top" title="跳撥到下一個例句"></i>
            <i class="fas fa-expand ml-auto" @click="expandVideo"></i>
            <i :class="[{'fa-turn-on':playbackRate!=1.0}, 'fas', 'fa-baby-carriage', 'my-auto', 'ml-4', 'mr-3']"
               data-toggle="tooltip" data-placement="top" title="切換娃娃車模式，放慢撥放速度" style="cursor:pointer;"
               v-on:click="togglePlaySpeed"></i>
            <i></i>
            <i :class="['my-auto', 'mr-3', {'fa-turn-on':showCaption}]"
               style="cursor:pointer;font-style:normal;" v-on:click="switchCaption()"
               data-toggle="tooltip" data-placement="top" title="顯示字幕"
               v-if="videoCaptions && !disableSubtitles">Việt</i>
            <i class="fas fa-tags my-auto mr-2 fa-disabled" style="cursor:pointer;"
               data-toggle="tooltip" data-placement="top" title="影片的標籤管理"></i>
        </div>
        <!--
    <div class="youtube-image-link">
        <a href="#">
            <img class="w-100 videoInfo-img"
                 :src="'https://img.youtube.com/vi/'+videoInfo.VideoId+'/hqdefault.jpg'" alt="">
        </a>
    </div>
    -->
    </div>
</template>
    
<script>
    import MobileDetect from 'mobile-detect';

    // 2. This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');

    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    var isYoutubeReady = false;
    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    // assigned to window to prevent be dropped by webpack
    window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
        isYoutubeReady = true;
    };
    
    export default {
        props: {
            videoInfo: {
                type: Object,
                default: function () { return {}; }
            },
            videoCaptions: {
                type: Array,
                default: function () { return []; }
            },
            dictCaptions: {
                type: Object,
                default: function () { return {}; }
            },
            autoplay: {
                type: Boolean,
                default: true,
            },
            disableSubtitles: {
                type: Boolean,
                default: false,
            },
            videoLoadStart: {
                type: Number,
                default: 0
            }
        },
        data: function() {
            return {
                // variables of player state
                playerCreator: null,
                player: null,
                playerState: -1,
                playbackRate: 1.0,

                showCaption: false,

                // varaibles of command panel
                defaultPlayingBuffer: 0.5,
                isSinglePlaying: false,
                isRepeating: false,
                singlePlayStopper: null,
                playingCaptionChecker: null,
                playingCaptionCheckCount: 0,
                playingCaption: null,
                playingCaptionIndex: null,
                nextplayingCaptionIndex: null,
                nextPlayingCaption: null,
                prevPlayingCaption: null,
                prevPlayingCaptionIndex: null,
                expandVideoData:true,
            };
        },
        methods: {
            expandVideo: function () {
                this.expandVideoData =! this.expandVideoData
                this.$emit('pushexpandVideoData', this.expandVideoData)
            },
            // player command 
            switchCaption: function () {
                if (!this.videoCaptions) {
                    return;
                }

                this.showCaption = !this.showCaption;
            },
            togglePlaySpeed: function () {
                this.playbackRate = this.playbackRate == 1.0 ? 0.5 : 1.0;
                this.player.setPlaybackRate(this.playbackRate);
            },
            createSinglePlayStopper: function (curTime) {
                // calc the time to fire stopper
                var playingEndTime = this.playingCaption.Start + this.playingCaption.Duration + this.defaultPlayingBuffer;
                var timeLeft2StopPlaying = (playingEndTime - curTime) * 1000;

                console.log('Creating the single play stopper, firing after ' + timeLeft2StopPlaying + ' ms');
                this.singlePlayStopper = setTimeout(this.pauseVideo, timeLeft2StopPlaying / this.playbackRate);
            },
            prevCaption: function () {
                if (this.player && (this.nextPlayingCaption || this.playingCaption)) {
                    var gotoIndex;
                    if (this.playingCaption) {
                        gotoIndex = this.playingCaptionIndex - 1;
                        if (gotoIndex < 0) {
                            gotoIndex = 0;
                        }
                    } else {
                        gotoIndex = this.nextPlayingCaptionIndex - 2;
                        if (gotoIndex < 0) {
                            gotoIndex = 0;
                        }
                    }

                    var gotoCap = this.videoCaptions[gotoIndex];
                    this.playCaption(gotoCap);
                }
            },
            repeatSentence: function () {
                let curTime = null;
                if (this.isRepeating) {
                    this.$emit('video-repeat-end', repeatTime);
                    if (this.playerState == 1) {
                        // still playing, we help to emit play start event here.(continus playing)
                        curTime = this.player.getCurrentTime();
                        // we help to emit video play end event
                        this.$emit('video-play-start', curTime);
                    }
                    this.isRepeating = !this.isRepeating;
                } else {
                    if (this.playerState == 1) {
                        curTime = this.player.getCurrentTime();
                        var repeatTime = this.playingCaption ? this.playingCaption.Start
                            : this.nextPlayingCaption ? this.nextPlayingCaption.Start
                                : 0;    // cannot find playing & next playing caption

                        // still in playing state, we help to emit video play end event
                        this.$emit('video-play-end', curTime);
                        this.$emit('video-repeat-start', repeatTime);

                        this.isRepeating = !this.isRepeating;

                        // 馬上從頭開始 repeat
                        if (this.playingCaption) {
                            this.playCaption(this.playingCaption);
                        } else if (this.prevPlayingCaption) {
                            this.playCaption(this.prevPlayingCaption);
                        } else if (this.nextPlayingCaption) {
                            this.playCaption(this.nextPlayingCaption);
                        }
                    } else {
                        this.$emit('video-repeat-start', null);
                        this.isRepeating = !this.isRepeating;
                    }


                }
            },
            /* this is private method, outside player please use playCaption instead */
            seekToSentence: function (cap) {
                if (this.player) {
                    var capIdx = this.dictCaptions[cap.Id].idx;

                    this.prevPlayingCaption = this.playingCaption;
                    this.prevPlayingCaptionIndex = this.playingCaptionIndex;
                    this.playingCaption = cap;
                    this.playingCaptionIndex = capIdx;
                    if (capIdx + 1 < this.videoCaptions.length) {
                        this.nextPlayingCaption = this.videoCaptions[capIdx + 1];
                        this.nextPlayingCaptionIndex = capIdx + 1;
                    } else {
                        this.nextPlayingCaption = null;
                        this.nextPlayingCaptionIndex = null;
                    }

                    if (this.player && this.player.seekTo) {
                        console.log('Seek to position: ' + Math.ceil(this.playingCaption.Start));
                        this.player.seekTo(Math.ceil(this.playingCaption.Start), true);
                    }
                }
            },
            playCaption: function (cap) {
                console.log('playCaption is called. cap.No: ' + cap.No);
                if (this.playerState == 1) {
                    this.clearPlayingCaptionChecker();

                    // playing, we help to send the play end event
                    var curTime = this.player.getCurrentTime();

                    if (!this.isRepeating && !this.isSinglePlaying) {
                        this.$emit('video-play-end', curTime);
                    }
                }

                this.seekToSentence(cap);

                if (this.playingCaption != this.prevPlayingCaption) {
                    if (this.playingCaption) {
                        this.capOriginal = this.playingCaption.Text;
                    }

                    if (this.translations && this.playingCaption.Id in this.translations) {
                        this.capTranslation = this.translations[this.playingCaption.Id];
                    } else {
                        this.capTranslation = null;
                    }

                    this.$emit('video-playing-caption-changed', this.prevPlayingCaption, this.playingCaption);
                }
            },
            /* 只播放單句 */
            playCaptionSingle: function (cap) {
                if (!this.player) {
                    console.log('Player is not ready, skip single caption playing.');
                    return;
                }

                this.player.pauseVideo();
                this.isSinglePlaying = true;

                this.seekToSentence(cap);
                this.player.playVideo();
            },
            playVideo: function () {
                if (this.player && this.playerState != 1) {
                    this.player.playVideo();
                }
            },
            pauseVideo: function () {
                if (this.player && this.playerState == 1) {
                    this.player.pauseVideo();
                }
            },
            nextCaption: function () {
                if (this.player && this.nextPlayingCaption) {
                    this.playCaption(this.nextPlayingCaption);
                }
            },
            checkPlayingCaption: function () {
                // cancel the flasher timer
                if (this.playingCaptionChecker) {
                    clearTimeout(this.playingCaptionChecker);
                    this.playingCaptionChecker = null;
                }

                /* logic to maintain playing variables and emit video-playing-caption-changed event:
                 * playingCaption,
                 * playingCaptionNo,
                 * nextPlayingCaption,
                 */
                var playingBuffer = this.isRepeating ? this.defaultPlayingBuffer : 0;
                var curTime = this.player.getCurrentTime();
                if (this.playingCaption) {
                    // 之前已經播放中了
                    if (this.isRepeating) {
                        var startTime = this.playingCaption.Start - playingBuffer;
                        if (startTime < 0) {
                            startTime = 0;
                        }

                        curTime = startTime;

                        this.prevPlayingCaption = this.playingCaption;
                        this.prevPlayingCaptionIndex = this.playingCaptionIndex;
                        this.player.seekTo(startTime, true);
                    } else {
                        // reach the playing end of prev. playing caption
                        console.log('reach the playing end, set playingCaption to null');
                        this.prevPlayingCaption = this.playingCaption;
                        this.prevPlayingCaptionIndex = this.playingCaptionIndex;
                        this.playingCaption = null;
                        this.playingCaptionIndex = null;

                        if (this.nextPlayingCaption == null) {
                            // no more cap to play
                            this.capOriginal = null;
                            this.capTranslation = null;
                        }
                    }

                } else {
                    // 之前的狀態是等待下個字幕的播放時間到來
                    if (this.nextPlayingCaption) {
                        // if we have no playing but have next playing, the next playing caption here will be the playing caption
                        console.log('reach the end of next playing, we set playingCaption to nextPlayingCaption');
                        console.log('Set playingCaption to nextPlayingCaption, no: ' + this.nextPlayingCaption.No);
                        this.prevPlayingCaption = this.playingCaption;
                        this.prevPlayingCaptionIndex = this.playingCaptionIndex;
                        this.playingCaption = this.nextPlayingCaption;
                        this.playingCaptionIndex = this.nextPlayingCaptionIndex;
                        var playingCaptionNo = this.playingCaption.No;
                        if (this.nextPlayingCaptionIndex + 1 < this.videoCaptions.length) {
                            this.nextPlayingCaptionIndex = this.nextPlayingCaptionIndex + 1;
                            this.nextPlayingCaption = this.videoCaptions[this.nextPlayingCaptionIndex];
                            console.log('Move nextPlayingCaption to caption no: ' + this.nextPlayingCaption.No);
                        } else {
                            this.nextPlayingCaption = null;
                            this.nextPlayingCaptionIndex = null;
                        }

                        if (this.playingCaption) {
                            this.capOriginal = this.playingCaption.Text;
                        }

                        if (this.translations && this.playingCaption.Id in this.translations) {
                            this.capTranslation = this.translations[this.playingCaption.Id];
                        } else {
                            this.capTranslation = null;
                        }
                        this.$emit('video-playing-caption-changed', this.prevPlayingCaption, this.playingCaption);
                    } else {
                        // no playing caption and no next playing record, completely new start, find the playing senetence first
                        console.log('The completely new playing, finding the playing/nextPlayingCaption');
                        if (this.videoCaptions) {
                            for (var i = 0; i < this.videoCaptions.length; i++) {
                                var curCaption = this.videoCaptions[i];
                                if (curCaption.Start <= curTime && curTime < (curCaption.Start + curCaption.Duration)) {
                                    this.playingCaption = curCaption;
                                    this.playingCaptionIndex = i;
                                    playingCaptionNo = curCaption.No;
                                    console.log('Found the playig caption, no: ' + playingCaptionNo + ', indexAt: ' + i);
                                    if ((i + 1) < this.videoCaptions.length) {
                                        this.nextPlayingCaption = this.videoCaptions[i + 1];
                                        this.nextPlayingCaptionIndex = i + 1;
                                        console.log('Found the next playig caption, no: ' + this.nextPlayingCaption.No);
                                    } else {
                                        this.nextPlayingCaption = null;
                                        this.nextPlayingCaptionIndex = null;

                                    }

                                    if (this.playingCaption) {
                                        this.capOriginal = this.playingCaption.Text;
                                    }

                                    if (this.translations && this.playingCaption.Id in this.translations) {
                                        this.capTranslation = this.translations[this.playingCaption.Id];
                                    } else {
                                        this.capTranslation = null;
                                    }
                                    this.$emit('video-playing-caption-changed', this.prevPlayingCaption, this.playingCaption);
                                    break;
                                } else if (curCaption.Start > curTime) {
                                    // cannot find playing but found next playing
                                    this.nextPlayingCaption = curCaption;
                                    this.nextPlayingCaptionIndex = i;
                                    console.log('Cannot find playingCaption but found the next playig caption, no: ' + this.nextPlayingCaption.No);
                                    break;
                                }
                            }
                        }
                    }
                }

                // logic to create the timer for next checker
                if (this.playingCaption) {
                    // 時間落在某個字幕內了。
                    // create the updater to clear the playing icon.
                    var playingEndTime = this.playingCaption.Start + this.playingCaption.Duration + playingBuffer;
                    var timeLeft2PlayingEnd = (playingEndTime - curTime) * 1000;
                    this.playingCaptionCheckCount++;

                    if (this.isRepeating) {
                        console.log('Creating playingCaptionChecker(Repeating) #' + this.playingCaptionCheckCount + ', current time: ' + curTime + ', playing end time: ' + playingEndTime + ', timeout to fire: ' + timeLeft2PlayingEnd + ' ms');
                    } else {
                        console.log('Creating playingCaptionChecker(Playing, wait to reset) #' + this.playingCaptionCheckCount + ', current time: ' + curTime + ', playing end time: ' + playingEndTime + ', timeout to fire: ' + timeLeft2PlayingEnd + ' ms');
                    }

                    this.playingCaptionChecker = setTimeout(this.checkPlayingCaption, timeLeft2PlayingEnd / this.playbackRate);
                } else if (this.nextPlayingCaption) {
                    // 還沒有播放到有字幕的地方，我們計算到下個字幕的時間，並建立計時器
                    // create updater to set the playing icon of next playing
                    var nextStartTime = this.nextPlayingCaption.Start;
                    var timeLeft2fire = (nextStartTime - curTime) * 1000;
                    this.playingCaptionCheckCount++;

                    console.log('Creating playingCaptionChecker(Waiting next playing) #' + this.playingCaptionCheckCount + ', current time: ' + curTime + ', next start time: ' + nextStartTime + ', timeout to fire: ' + timeLeft2fire + ' ms');
                    this.playingCaptionChecker = setTimeout(this.checkPlayingCaption, timeLeft2fire / this.playbackRate);
                }
            },
            clearPlayingCaptionChecker() {
                if (this.playingCaptionChecker) {
                    clearTimeout(this.playingCaptionChecker);
                    this.playingCaptionChecker = null;
                }
            },
            clearAllTimer: function () {
                this.clearPlayingCaptionChecker();

                if (this.singlePlayStopper) {
                    clearTimeout(this.singlePlayStopper);
                    this.singlePlayStopper = null;
                }
            },
            // player creation related
            recreatePlayer: function () {
                this.playerCreator = null;

                console.log('Creating YT player');
                if (this.player) {
                    console.log('Player alreay created, skip the player creation.');
                    return;
                }

                if (!isYoutubeReady) {
                    console.log('Youtube api is not ready, create the timer to delay the creation job.');
                    this.playerCreator = setTimeout(this.recreatePlayer, 500);
                    return;
                }

                console.log('The video start position while creating player: ' + this.videoLoadStart);

                /* global YT */
                this.player = new YT.Player('player', {
                    videoId: this.videoInfo.VideoId,
                    events: {
                        'onReady': this.onPlayerReady,
                        'onStateChange': this.onPlayerStateChange,
                        'onPlaybackRateChange': this.onPlaybackRateChange
                    },
                    playerVars: {
                        playsinline: 1,
                        start: this.videoLoadStart,
                        cc_load_policy: 3,
                    },
                });
            },
            // 4. The API will call this function when the video player is ready.
            onPlayerReady: function (event) {
                if (this.autoplay) {
                    var md = new MobileDetect(window.navigator.userAgent);
                    if (md.os() == 'iOS') {
                        if (!md.mobile()) {
                            event.target.playVideo();
                        }
                    } else {
                        event.target.playVideo();
                    }
                }
            },
            // 5. The API calls this function when the player's state changes.
            //    The function indicates that when playing a video (state=1),
            //    the player should play for six seconds and then stop.
            onPlayerStateChange: function (event) {
                var curTime = this.player.getCurrentTime();

                this.playerState = event.data;
                switch (this.playerState) {
                    case YT.PlayerState.CUED:
                        console.log('onPlayerStateChange is called, event = CUED, time: ' + curTime);
                        break;

                    case YT.PlayerState.PLAYING:
                        console.log('onPlayerStateChange is called, event = PLAYING, time: ' + curTime);

                        // emit events
                        if (this.isSinglePlaying) {
                            this.$emit('video-singleplay-start', curTime);
                            this.$eventBus.$emit('video-singleplay-start', curTime);
                        } else if (!this.isRepeating) {
                            this.$emit('video-play-start', curTime);
                        }

                        if (this.isSinglePlaying) {
                            // create single play stopper here
                            this.createSinglePlayStopper(curTime);
                        } else if (!this.playingCaptionChecker) {
                            console.log('executing checkPlayingCaption in player state change(playing).');

                            this.playingCaption = null;
                            this.playingCaptionIndex = null;
                            this.nextPlayingCaptionIndex = null;
                            this.nextPlayingCaption = null;
                            this.prevPlayingCaption = null;
                            this.prevPlayingCaptionIndex = null;
                            this.capTranslation = null;
                            this.capOriginal = null;

                            this.checkPlayingCaption();
                        } else {
                            console.log('skip executing checkPlayingCaption in player sate change(playing).')
                        }
                        break;

                    case YT.PlayerState.PAUSED:
                        console.log('onPlayerStateChange is called, event = PAUSED, time: ' + curTime);

                        this.clearAllTimer();

                        // emit events
                        if (this.isSinglePlaying) {
                            this.$emit('video-singleplay-end', curTime);
                            this.$eventBus.$emit('video-singleplay-end', curTime);
                            this.isSinglePlaying = false;
                        } else if (this.isRepeating) {
                            this.$emit('video-repeat-end', curTime);
                        } else {
                            this.$emit('video-play-end', curTime);
                        }
                        break;

                    case YT.PlayerState.BUFFERING:
                        console.log('onPlayerStateChange is called, event = BUFFERING, time: ' + curTime);
                        // buffering 代表是跳撥，不在這裡紀錄 user watch time, 跳撥之前就要存了
                        break;

                    case YT.PlayerState.ENDED:
                        console.log('onPlayerStateChange is called, event = ENDED, time: ' + curTime);

                        this.clearAllTimer();

                        // emit events
                        if (this.isSinglePlaying) {
                            this.$emit('video-singleplay-end', curTime);
                            this.$eventBus.$emit('video-singleplay-end', curTime);
                            this.isSinglePlaying = false;
                        } else if (this.isRepeating) {
                            this.$emit('video-repeat-end', curTime);
                        } else {
                            this.$emit('video-play-end', curTime);
                        }
                        break;

                    default:
                        console.log('onPlayerStateChange is called, event = Unknown(' + this.playerState + '), time: ' + curTime);
                        break;
                }
            },
            onPlaybackRateChange: function (r) {
                this.playbackRate = r.data;
            },
        },
        mounted: function () {
            this.recreatePlayer();
        },
        watch: {
        },
        computed: {

        },
    };
</script>
    
<style lang="css">
    /* css from gary*/
    .videoInfo-img {
        height: 200px;
        object-fit: cover;
        border-radius: 10px;
    }

    /* css of original yyplayer*/

    #player {
        width: 100%;
    }
    .video-tool-wrap{
        font-size: 1.3rem;
        margin-top: 10px;
    }
    iframe{
        height: 270px!important;
    }
    .fa-turn-on{
        color:#456CEB;
    }
    .fa-play:hover,.fa-forward:hover,.fa-pause:hover,.fa-backward:hover,.fa-redo-alt:hover,.fa-baby-carriage:hover,.fa-disabled:hover,.fa-expand:hover{
         color:#456CEB;       
    }

    .fa-play,.fa-forward,.fa-pause,.fa-backward,.fa-redo-alt,.fa-baby-carriage,.fa-disabled,.fa-expand{
         cursor: pointer!important;    
    }

    .fa-expand{
        cursor: pointer;
    }

    @media (min-width: 768px){
        .open-video-height iframe{
            height: 800px!important;
        }
    }

</style>